/** @jsxImportSource @emotion/react */
import { createStyles, Icon, useTheme } from '@quickbit/qb-design-system';

interface MerchantLogoProps {
  merchantName?: string;
  logoUrl: string;
}

export const MerchantLogoSection = ({
  merchantName,
  logoUrl,
}: MerchantLogoProps) => {
  const { spacing } = useTheme();

  const styles = useStyles();
  return (
    <>
      <div css={styles.logoSectionContainer}>
        <div css={styles.qbIconContainer}>
          <Icon size={spacing.l} name="qb" />
        </div>
        <div css={styles.dotsContainer}>
          {Array.from({ length: 3 }).map((_, index: number) => (
            <div key={index} css={styles.dot}></div>
          ))}
        </div>
        <div css={styles.merchantLogoContainer}>
          <img
            src={logoUrl}
            alt={`${merchantName} logo`}
            css={styles.merchantLogoImg}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = createStyles(({ palette, spacing }) => ({
  logoSectionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: spacing.xxs,
    margin: spacing.xs,
  },
  qbIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '96px',
    width: '96px',
    backgroundColor: palette.primary.default,
    borderRadius: '50%',
    svg: { color: palette.secondary.x500 },
  },
  dotsContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: spacing.xxxs,
  },
  dot: {
    height: '7px',
    width: '7px',
    borderRadius: '50%',
    backgroundColor: palette.grey.x900,
  },
  merchantLogoContainer: {
    border: `1px solid ${palette.grey.x100}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '96px',
    height: '96px',
  },
  merchantLogoImg: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    borderRadius: '50%',
  },
}));
